/**
 * This code is copied from the source code of Theatre.js
 * License is hearby granted under Apache Public License 2.0
 * License owner: TheaterJS Oy
 * Contact: aria@theatrejs.com
 */

import * as css from './createCursorLock.css'

export default function createCursorLock(cursor: string) {
  const el = document.createElement('div')
  el.classList.add(css.container)
  el.style.cursor = cursor
  document.body.appendChild(el)
  const relinquish = () => {
    document.body.removeChild(el)
  }

  return relinquish
}



// WEBPACK FOOTER //
// ./src/common/createCursorLock.ts